import React from 'react';
import { LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
export function TopBar() {
  return <header className="sticky top-0 z-50 border-b border-pink-100 bg-white/95 shadow-sm backdrop-blur" data-id="element-227" data-mp="232nfsn0fptzi">
      <div className="bg-primary px-3 py-1.5 text-center text-[10px] font-extrabold uppercase tracking-wide text-white sm:text-xs md:text-sm" data-id="element-228" data-mp="1y4ve519zmti4">
        🇦🇷 El sistema N°1 para instructores de Jumping en Argentina
      </div>
      <div className="mx-auto hidden max-w-5xl items-center justify-center gap-7 py-2 text-xs font-semibold text-slate-500 md:flex" data-id="element-229" data-mp="2qryc9sar527u">
        <span className="flex items-center gap-1.5" data-id="element-230" data-mp="2h2oj09469di5">
          <ZapIcon className="h-3.5 w-3.5 text-primary" data-id="element-231" data-mp="2h1dcw2n97tnv" /> Acceso en 5 minutos
        </span>
        <span className="text-pink-300" data-id="element-232" data-mp="2c2sdg5ftte0h">·</span>
        <span className="flex items-center gap-1.5" data-id="element-233" data-mp="2c1qy3ors25cy">
          <LockIcon className="h-3.5 w-3.5 text-primary" data-id="element-234" data-mp="39jr25duiy7bc" /> Pago seguro
        </span>
        <span className="text-pink-300" data-id="element-235" data-mp="34r7qimfedm96">·</span>
        <span className="flex items-center gap-1.5" data-id="element-236" data-mp="34q65pq8kxle9">
          <ShieldCheckIcon className="h-3.5 w-3.5 text-primary" data-id="element-237" data-mp="26al2anej3uq" /> Garantía de 7 días
        </span>
      </div>
    </header>;
}